export default function SocialFreebsdDevil() {
  return (
    <div
      className="ion-icon-social-freebsd-devil"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<path class="st0" d="M502.6,115c-22.5-43.7-58-51-58-51s15.5,32,16,51c0.4,16.1-5.5,28-27.2,33.5s-30.8-2-47.8-17.5
	S344,104.5,313,103c-40-2-77,9-77,9c-20-25,20-80,20-80c-74.5,29.5-93.7,83.3-96,113.7c-1.9,24.1,8.5,40.8,8.5,40.8s-0.5,27.8-5,42
	c-3.1,9.8-16.9,25-26,34.5c-12.2,12.7-12.5,38.5,0,57s44,27.5,67,39.5s31.5,21,31.5,21s1,8.3,0.5,15.3s-3.2,14-9,18.2
	c-5.5,3.9-15.5,0.5-20.5-2s-5-6.2-10.5-8s-7.3-4-6.5-11s2-9-3.5-18.5s-18.5-9.5-29.5-8s-17.3,6.8-17.3,6.8l-16.3-10
	c0,0,8.5-15.6,5.2-35.6c-7.3-43.8-50-62.8-50-62.8l10.4,44.4c0,0,1.1-2.6,6.4-6.4s8.1-3.6,8.1-3.6s6.6,7.6,9.1,25.3
	c2.5,18-6.7,27.2-6.7,27.2l-28.3-18l1-14.5L39.8,309L56,345.7l15-4l24,22.7c0,0-15.7,11.7-33,11.7c-11,0-22-6-22-6s-1.4-1-0.8-5.5
	c0.7-5,6.8-12.5,6.8-12.5H0c0,0,27.3,38.7,65,38.7c31,0,44.2-12.5,44.2-12.5L128,397c0,0,3,5.5,0,7s-7,3.5-9,15s18,29,18,29
	c21.8,17.8,7,32,7,32h272c-9-13-22.5-18-32-32c0,0-44.8-58.4-1.8-90.4c57.4-42.7,42.8-69.4,41.2-101.4c0,0,31.8-6.6,59.3-33.6
	S521.6,151.8,502.6,115z M195,203c-16.9,4.5-22.5,35.5-22.5,35.5c1.5-63,57.5-93,65-89s-6.5,39-21,64
	C216.5,213.5,208.5,199.4,195,203z M232,218c0,0,18-56,37.5-59.5s41.5,21,41.5,62s-26,65.4-42.8,69.2c-16.5,3.8-23,2-23,2
	s27.5-21.6,23.5-56.8C265.9,210.2,237.3,210.7,232,218z"/>
</svg>
`,
      }}
    />
  )
}
